import React from 'react'; import ExtendedModulePage from './ExtendedModulePage'; export default function IncomePage(){return <ExtendedModulePage moduleKey="incomes"/>}
